import * as React from "react";
import { Row, Col } from "react-bootstrap";
import { LoadingText } from "./LoadingText";
import { Utils } from "../../common/utils";
import CONFIG from "Config";

interface AuthProcessingTemplateProps {
    loadingText: string;
    errorTitle?: string;
    errorMessage?: string;
    showError?: boolean;
    onRetryClick?: () => void;
}

export function AuthProcessingTemplate({
    loadingText,
    errorTitle = "Authentication Error",
    errorMessage = "Please try logging in again.",
    showError = false,
    onRetryClick
}: AuthProcessingTemplateProps) {
    const handleRetryClick = () => {
        if (onRetryClick) {
            onRetryClick();
        } else {
            // Default behavior: redirect to login
            window.location.href = CONFIG.paths.base + "login";
        }
    };

    return (
        <React.Fragment>
            <Row className="login">
                <Col md="6" className="left text-center">
                    <div className="logo"/>
                </Col>
                <Col md="6" className="right">
                    <div className="center">
                        {showError ? (
                            <div style={{ padding: "20px", textAlign: "center" }}>
                                <h3>{errorTitle}</h3>
                                <p>{errorMessage}</p>
                                <a href="#" onClick={handleRetryClick}>Return to Login</a>
                            </div>
                        ) : (
                            <LoadingText text={loadingText} />
                        )}
                    </div>
                    <div className="privacy-policy">
                        By logging into Enflux, you agree to our <a target="_blank" rel="noopener noreferrer" href="https://enflux.com/legal/">Terms of
                        Use</a> and <a target="_blank" rel="noopener noreferrer" href="https://enflux.com/privacy/">Privacy Policy</a>.
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div id="copy-div" className="copyright">© 2017 - {Utils.getCurrentYear()} Enflux. All Rights Reserved</div>
                </Col>
            </Row>
        </React.Fragment>
    );
}